/**
 * The partner agreement clauses rendered for the signer to read (node P1). These
 * MIRROR the server canonical text (workers/src/lib/esign.ts
 * CANONICAL_AGREEMENT_CLAUSES) with the product name substituted. The legally
 * binding record is the SERVER template that signAgreement snapshots; this is the
 * faithful on-screen rendering the partner reads before adopting a signature.
 */
export interface DisplayClause {
  n: number;
  title: string;
  body: string;
}

export function agreementClauses(product: string): DisplayClause[] {
  return [
    { n: 1, title: "Appointment", body: `${product} appoints you to promote its product using approved links and assets.` },
    { n: 2, title: "Reward", body: "You earn 20% of each payment from customers you refer, while they stay, paid after a 30 day hold." },
    { n: 3, title: "Attribution", body: "Last click wins inside a 30 day window." },
    { n: 4, title: "Conduct", body: `No self referral. No bidding on ${product} brand terms. Use approved assets only.` },
    { n: 5, title: "Disclosure", body: 'When you promote, clearly and visibly disclose that you earn a commission, using words like #ad or "paid link". This is required by law and both sides are responsible.' },
    { n: 6, title: "Payment", body: "Paid per this agreement using the details you provide. Flashadz records amounts and does not move money." },
    { n: 7, title: "Term", body: "Either side may end this with notice. Rewards already earned and cleared are still paid." },
  ];
}
